import { AppliedAdditionalCharge, TaxLine } from 'store/invoices/types';

export enum InvoiceDetailsTabs {
    OVERVIEW = 'overview',
    HISTORY = 'history',
}

export type InvoiceFieldValues = {
    invoiceDetails: {
        invoiceNumber: string;
        orderNumber: string;
        mrn: string;
        jobRefNumber: string;
        dueDate: string;
    };
    customerDetails: {
        name: string;
        address: string;
        city: string;
        postCode: string;
        country: string;
    };
    taxLines: TaxLine[];
    additionalCharges: AppliedAdditionalCharge[];
};

export type DashboardInvoicesData = {
    all: number;
    draft: number;
    toBePaid: number;
    paymentReceived: number;
    partiallyPaid: number;
    overdue: number;
    cancelled: number;
    aboutToBeDue: number;
    disputed: number;
};

export const initialInvoicesDashboardData: DashboardInvoicesData = {
    all: 0,
    draft: 0,
    toBePaid: 0,
    paymentReceived: 0,
    partiallyPaid: 0,
    overdue: 0,
    cancelled: 0,
    aboutToBeDue: 0,
    disputed: 0,
};

export type SubmitInvoiceChargeFormFields = {
    nominalCode: string;
    productCode: string;
    description: string;
    taxCode: string;
    amount: number | null;
    percentage?: number | null;
};
